import { Tab, Tabs } from '@mui/material';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';

export interface PageTabItem {
  text: string;
  path: string;
}

export type PageTabItems = Array<PageTabItem>;

export interface PageTabsProps {
  tabs: Array<PageTabItem>;
}

const PageTabs: React.FC<React.PropsWithChildren<PageTabsProps>> = ({ tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Tabs indicatorColor="primary" textColor="primary" value={location.pathname}>
      {tabs.map((tab, index) => (
        <Tab key={tab.path} id={`tab-${index}`} label={tab.text} onClick={() => navigate(tab.path)} value={tab.path} />
      ))}
    </Tabs>
  );
};

export default PageTabs;
